<template>
    <div class="velikost-legende">
        <p class="open-sans-20pt" style="text-align: left">
            Legenda računa
        </p>
        <table class="legenda">
            <tr>
                <td class="velikost-td glava">
                    Številka računa
                </td>
                <td class="vsebina">
                    Serijska številka računa, ki nam omogoča hitrejšo identifikacijo in obravnavo podatkov vezanih na
                    izdan račun.
                </td>
            </tr>
            <tr>
                <td class="glava">
                    Datum izdaje
                </td>
                <td class="vsebina">
                    Datum izdaje računa. Račune vedno izdamo za pretekli mesec uporabe storitev. Če je račun izdan
                    npr. 12. 03. 2020, pomeni, da smo storitve obračunali za mesec februar 2020.
                </td>
            </tr>
            <tr>
                <td class="glava">
                    Datum valute
                </td>
                <td class="vsebina">
                    Datum, do katerega je potrebno plačati račun.
                </td>
            </tr>
            <tr>
                <td class="glava">
                    Znesek računa
                </td>
                <td class="vsebina">
                    Znesek opravljenih storitev in/ali prodanega blaga.
                </td>
            </tr>
            <tr>
                <td class="glava">
                    Znesek plačila
                </td>
                <td class="vsebina">
                    Znesek prejetega plačila izdanega računa.
                </td>
            </tr>
            <tr>
                <td class="glava">
                    Plačano
                </td>
                <td class="vsebina">
                    Stanje prejetega plačila.
                </td>
            </tr>
            <tr>
                <td class="glava">
                    Datum plačila
                </td>
                <td class="vsebina">
                    Datum, kdaj smo prejeli plačilo.
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
  export default {
    name: 'LegendaIzdaniRacuni'
  }
</script>

<style scoped src="../../../../../../static/css/MojT-2/Racuni/LegendaIzdaniRacuni.css">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Racuni/LegendaIzdaniRacuni.vue